import moment from 'moment';
import { useOrderStore } from 'store/orderStore';
import _ from 'lodash';
import {
  AdType,
  CreativeDeliverType,
  DeliverType,
  RtbCampaignPlanType,
  RTBCAMPAIGN_DEFAULT_AGE_MAX,
  RTBCAMPAIGN_DEFAULT_AGE_MIN,
} from 'core/rtbCampaign/RtbCampaign';
import { BidStrategy, L2ObjectOptimizationGoal } from 'core/l2Object/L2Object';
import {
  SelectPattern,
  RunningPattern,
  BudgetType,
} from 'core/rtbCampaign/singlePage/common';
import { BidMode, RoasStrategy } from 'core/rtbCampaign/singlePage/keyword';

const DATE_FORMAT = 'yyyy-MM-DD HH:mm:ss';

function useCreateKeyword() {
  const order = useOrderStore().order;

  const useCampaignStartDay = () => {
    const now = moment().startOf('hour').add(1, 'hour');
    const orderStartDate = moment(order.startDate);
    return now.isBefore(orderStartDate) ? orderStartDate : now;
  };

  const useCampaignEndDay = () => {
    return moment.min(
      moment(order.endDate).add(1, 'days').subtract(1, 'seconds'),
      moment(useCampaignStartDay())
        .add(13, 'days')
        .endOf('day')
        .subtract(1, 'seconds'),
    );
  };

  const getDefaultCampaign = (
    startDate: moment.Moment,
    endDate: moment.Moment,
  ) => {
    const ageLimitationPresets = [
      {
        type: 'age_min',
        value: RTBCAMPAIGN_DEFAULT_AGE_MIN,
      },
      {
        type: 'age_max',
        value: RTBCAMPAIGN_DEFAULT_AGE_MAX,
      },
    ];

    const genderLimitationPresets = [];

    const limitationPreSet = {
      preferred: [...ageLimitationPresets, ...genderLimitationPresets],
    };

    const defaultCampaign = {
      basic: {
        advertiserId: order.advertiserId,
        orderId: order.id,
        adType: AdType.MAX_CVR_KEYWORD,
        name: order.projectName,
        budget: null, //order.budgetBalance
        dailyTargetBudget: null,
        spents: 0,
        expectedSpent: 0,
        bidPrice: undefined,
        startDate: startDate.format(DATE_FORMAT),
        endDate: endDate.format(DATE_FORMAT),
        checkpoints: [],
        creativeDeliverType: CreativeDeliverType.OPTIMIZE,
        priceModel: RtbCampaignPlanType.RS_CPC,
        optimize: L2ObjectOptimizationGoal.CLICKS,
        deliverType: DeliverType.ACCELERATED,
        enableOutbound: false,
        bidStrategy: BidStrategy.LOWEST_COST_WITH_BID_CAP,
        webBrandNo: null,
        brandName: null,
        budgetType: BudgetType.DAILY,
        selectPattern: SelectPattern.AUTO,
        runningPattern: RunningPattern.UNLIMITED,
        bidMode: BidMode.AUTO,
        roasOption: {
          roasStrategy: RoasStrategy.HIGH_ROAS,
          roas: null,
        },
      },
      limitations: _.cloneDeep(limitationPreSet),
      products: [],
      autoProducts: [],
      keywords: [],
    };
    return defaultCampaign;
  };

  const startDate = useCampaignStartDay();
  const endDate = useCampaignEndDay();

  return { getDefaultCampaign: () => getDefaultCampaign(startDate, endDate) };
}

export default useCreateKeyword;
